import { App } from 'vue'
import { Editor } from './components/Editor'

Editor.install = (Vue: App) => {
  Vue.component(Editor.name, Editor)
}

export default Editor
